import { render, staticRenderFns } from "./AlterarDadosUsuariosForm.vue?vue&type=template&id=260a3c92&scoped=true&"
import script from "./AlterarDadosUsuariosForm.vue?vue&type=script&lang=js&"
export * from "./AlterarDadosUsuariosForm.vue?vue&type=script&lang=js&"
import style0 from "./AlterarDadosUsuariosForm.vue?vue&type=style&index=0&id=260a3c92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260a3c92",
  null
  
)

export default component.exports